// src/components/pages/Produto/tabs/IndustriaTabPanel.jsx
import React, { useMemo } from 'react';

// estilo
import formStyles from '../../../form/Form.module.css';

// seus componentes (ajuste paths conforme seu projeto)
import InputFloat from '../../../form/InputFloat';
import InputNumber from '../../../form/InputNumber';
import Checkbox from '../../../form/Checkbox';
import DataList from '../../../form/DataList';
import Select from '../../../form/Select';

// MUI + MRT
import { ThemeProvider } from '@mui/material/styles';
import { Box, Tooltip, IconButton, Button } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { podeEditar, podeImprimir, podeIncluir, podeCancelar } from '../../../../hooks/usePermisionMRT';

/* utils */
import { formatarNumero, formatarNumero3Digitos } from '../../../../utils/masks';

const IndustriaTabPanel = ({
    module,
    theme,
    profile,
    // MRT
    mrt,
    isError,
    isLoading,
    isRefetching,
}) => {
    const {
        dados,
        parametro,
        ProdutoBobina,
        OptionsProdutoBobina,
        OptionsEmbalagemProducao,
        Cilindro,
        OptionsCilindro,
        Cor,
        OptionsCores,
        Anilox,
        OptionsAnilox,

        novaCor,
        produtoCores,
        rowCountCor,
    } = module.state;

    const { change: onChange, focus: onFocus, blur: onBlur, limparCor, saveCor, selectCorRow } = module.actions;
    const {
        columnFilterFns,
        setColumnFiltersMode,
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
    } = mrt;

    const columns = useMemo(
        () => [
            {
                id: 'cores',
                header: 'cores e anilox para o processo de produção do produto',
                columns: [
                    {
                        accessorKey: 'ordem',
                        header: 'Ordem',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'Cor.descricao',
                        header: 'Descrição',
                        //you can access a cell in many callback column definition options like this
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'Anilox.descricao',
                        header: 'Anilox',
                        cell: (info) => info.getValue() ?? 'N/A',
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.ativo ? 'Sim' : 'Não';
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    return (
        <div className={formStyles.stiloPadrao}>
            <h4>Informações relevantes no processo de industrialização do produto</h4>
            <div>
                <Checkbox
                    title="Informa que é uma matéria prima, para composição de outros produtos"
                    text="Matéria Prima"
                    name="materiaPrima"
                    handleOnChange={onChange}
                    value={dados.materiaPrima}
                    checked={!!dados.materiaPrima}
                />
                <Checkbox
                    title="Informa que é uma embalagem"
                    text="Embalagem"
                    name="embalagem"
                    handleOnChange={onChange}
                    value={dados.embalagem}
                    checked={!!dados.embalagem}
                />
                <InputNumber
                    text="Produção Mínima"
                    type="text"
                    name="producaoMinima"
                    placeholder="Produção mínima operacional"
                    inputWidth="100px"
                    title="digite o valor da produção mínima do produto"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.producaoMinima ? formatarNumero3Digitos(dados.producaoMinima) : ''}
                />
                <Select
                    name="embalagemProducaoId"
                    title="Selecione a embalagem utilizada no processo de produção do produto"
                    text="Embalagem Produção"
                    options={OptionsEmbalagemProducao}
                    handleOnChange={onChange}
                    value={dados.embalagemProducaoId}
                    isEnum={false}
                    notOptNull={false}
                />
            </div>
            {/* Padaria */}
            {parametro?.Empresa?.ramoAtividade === 'Padaria' && (
                <div>
                    <Checkbox
                        title="Rotina de produção"
                        text="Bancada"
                        name="bancada"
                        handleOnChange={onChange}
                        value={dados.bancada}
                        checked={!!dados.bancada}
                    />
                    <Checkbox
                        title="Rotina de produção"
                        text="Batedeira"
                        name="batedeira"
                        handleOnChange={onChange}
                        value={dados.batedeira}
                        checked={!!dados.batedeira}
                    />
                    <Checkbox
                        title="Rotina de produção"
                        text="Cilindro"
                        name="cilindro"
                        handleOnChange={onChange}
                        value={dados.cilindro}
                        checked={!!dados.cilindro}
                    />
                    <Checkbox
                        title="Rotina de produção"
                        text="Rolo"
                        name="rolo"
                        handleOnChange={onChange}
                        value={dados.rolo}
                        checked={!!dados.rolo}
                    />
                    <Checkbox
                        title="Rotina de produção"
                        text="Forno"
                        name="forno"
                        handleOnChange={onChange}
                        value={dados.forno}
                        checked={!!dados.forno}
                    />
                </div>
            )}
            {/* Industria */}
            {parametro?.Empresa?.ramoAtividade === 'Industria' && profile?.id !== 'bobina' && (
                <>
                    <div>
                        <InputFloat
                            text="Peso Molecular"
                            type="text"
                            name="pesoMolecular"
                            placeholder="peso molecular"
                            inputWidth="160px"
                            title="o peso molecular do produto, utilize como separador o ponto (.)) ex: 0.000000, Formula padrão Peso Produzido / quantidade = peso Molecular"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.pesoMolecular || ''}
                            textAlign={'right'}
                        />
                        <InputFloat
                            text="Tolerância mínima"
                            type="text"
                            name="toleranciaMinima"
                            placeholder=""
                            inputWidth="160px"
                            title="tolerância/peso mínimo em comparação com o peso molecular"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.toleranciaMinima}
                        />
                        <InputFloat
                            text="Tolerância máxima"
                            type="text"
                            name="toleranciaMaxima"
                            placeholder="Tolerência máxima"
                            inputWidth="160px"
                            title="tolerância/peso máximo em comparação com o peso molecular"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.toleranciaMaxima}
                        />
                    </div>
                    <div>
                        <Checkbox
                            title="Informa que o produto utiliza a rotina de separação"
                            text="Separação"
                            name="separacao"
                            handleOnChange={onChange}
                            value={dados.separacao}
                            checked={!!dados.separacao}
                        />
                        <Checkbox
                            title="Informa que o produto gera refugo"
                            text="Refugo"
                            name="refugo"
                            handleOnChange={onChange}
                            value={dados.refugo}
                            checked={!!dados.refugo}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza a rotina de lavagem"
                            text="Lavagem"
                            name="lavagem"
                            handleOnChange={onChange}
                            value={dados.lavagem}
                            checked={!!dados.lavagem}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza a rotina de produção"
                            text="Produção"
                            name="producao"
                            handleOnChange={onChange}
                            value={dados.producao}
                            checked={!!dados.producao}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza a rotina de extrusão"
                            text="Extrusão"
                            name="extrusao"
                            handleOnChange={onChange}
                            value={dados.extrusao}
                            checked={!!dados.extrusao}
                        />
                        <Checkbox
                            title="Informa que o prcesso de produção do produto finaliza na extrusão"
                            text="Finaliza Extrusão"
                            name="finalizaExtrusora"
                            handleOnChange={onChange}
                            value={dados.finalizaExtrusora}
                            checked={!!dados.finalizaExtrusora}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza da Recuperadora"
                            text="Recuperadora"
                            name="recuperadora"
                            handleOnChange={onChange}
                            value={dados.recuperadora}
                            checked={!!dados.recuperadora}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza da corrugadora"
                            text="Corrugadora"
                            name="corrugadora"
                            handleOnChange={onChange}
                            value={dados.corrugadora}
                            checked={!!dados.corrugadora}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza a rotina da impressora"
                            text="Impressão"
                            name="impressao"
                            handleOnChange={onChange}
                            value={dados.impressao}
                            checked={!!dados.impressao}
                        />
                        <Checkbox
                            title="Informa que o produto utiliza a rotina da corte e solda"
                            text="Corte Solda"
                            name="corteSolda"
                            handleOnChange={onChange}
                            value={dados.corteSolda}
                            checked={!!dados.corteSolda}
                        />
                        <Checkbox
                            title="Informa que o produto é laminado"
                            text="Laminado"
                            name="laminado"
                            handleOnChange={onChange}
                            value={dados.laminado}
                            checked={!!dados.laminado}
                        />
                        <Checkbox
                            title="Informa que o produto é sanfonado"
                            text="Sanfonado"
                            name="sanfonado"
                            handleOnChange={onChange}
                            value={dados.sanfonado}
                            checked={!!dados.sanfonado}
                        />
                    </div>
                    <div>
                        <DataList
                            text="Bobina"
                            title={'Vincula a bobina ao produto'}
                            name="ProdutoBobina.descricao"
                            inputWidth="350px"
                            filteredOptions={OptionsProdutoBobina}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={ProdutoBobina?.descricao || ''}
                        />
                        <DataList
                            text="Cilindro"
                            title={'Vincula o cilindro ao produto'}
                            name="Cilindro.descricao"
                            inputWidth="350px"
                            filteredOptions={OptionsCilindro}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={Cilindro?.descricao || ''}
                        />
                    </div>
                    {
                        // =========================
                        //      CORES + GRID
                        // =========================
                    }
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            <InputNumber
                                text="Ordem"
                                type="text"
                                name="novaCor.ordem"
                                placeholder="Ordem"
                                inputWidth="50px"
                                title="digite a ordem da cor"
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={novaCor?.ordem || ''}
                                textAlign="center"
                            />

                            <DataList
                                text="Cor"
                                title={'Vincula a cor para a produção do produto'}
                                name="novaCor.Cor.descricao"
                                inputWidth="350px"
                                filteredOptions={OptionsCores}
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={Cor?.descricao || ''}
                            />

                            <DataList
                                text="Anilox"
                                title={'Vincula o anilox a cor utilizada no cilindro para produção do produto'}
                                name="novaCor.Anilox.descricao"
                                inputWidth="350px"
                                filteredOptions={OptionsAnilox}
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={Anilox?.descricao || null}
                            />

                            <Checkbox
                                title="Ativa a cor"
                                text="Ativo"
                                name="novaCor.ativo"
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={novaCor?.ativo}
                                checked={!!novaCor?.ativo}
                            />

                            <Button variant="contained" color="inherit" onClick={limparCor} style={{ marginLeft: '10px' }}>
                                Limpar
                            </Button>

                            <Button
                                variant="contained"
                                // Se for deletar = vermelho, se for editar = laranja/warning, se for adicionar = azul/info
                                color={novaCor.funcao === 'Deletar' ? 'error' : novaCor.funcao === 'Editar' ? 'warning' : 'info'}
                                onClick={saveCor}
                                disabled={!novaCor?.ordem || !novaCor?.corId}
                                style={{ marginLeft: '5px' }}
                            >
                                {novaCor?.funcao || 'Adicionar'}
                            </Button>
                        </div>

                        <ThemeProvider theme={theme}>
                            <MaterialReactTable
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        muiTableHeadCellProps: { align: 'center' },
                                        size: 100,
                                    },
                                    'mrt-row-numbers': {
                                        enableColumnOrdering: true,
                                        enableResizing: true,
                                        muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                                    },
                                    'mrt-row-select': {
                                        enableColumnActions: false,
                                        enableHiding: true,
                                        size: 50,
                                    },
                                }}
                                enableColumnFilterModes
                                enableGlobalFilterModes
                                enableColumnOrdering
                                enableEditing
                                renderRowActions={({ row }) => (
                                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                                        <Tooltip arrow placement="top" title="Editar">
                                            <span>
                                                <IconButton
                                                    onClick={() => selectCorRow(row.original, row.index, 'Editar')}
                                                    disabled={!podeEditar}
                                                >
                                                    <Edit />
                                                </IconButton>
                                            </span>
                                        </Tooltip>

                                        <Tooltip arrow placement="right" title="Deletar">
                                            <span>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => selectCorRow(row.original, row.index, 'Deletar')}
                                                    disabled={!podeCancelar}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                )}
                                columns={columns}
                                data={produtoCores}
                                rowCount={rowCountCor}
                                enableRowSelection
                                getRowId={(row) => row.uuid}
                                manualFiltering
                                manualPagination
                                manualSorting
                                muiToolbarAlertBannerProps={
                                    isError
                                        ? {
                                              color: 'error',
                                              children: 'Error loading data',
                                          }
                                        : undefined
                                }
                                onColumnFiltersChange={setColumnFilters}
                                onColumnFilterFnsChange={setColumnFiltersMode}
                                onGlobalFilterChange={setGlobalFilter}
                                onPaginationChange={setPagination}
                                onSortingChange={setSorting}
                                initialState={{
                                    showColumnFilters: true,
                                    density: 'compact',
                                }}
                                state={{
                                    columnFilterFns,
                                    columnFilters,
                                    globalFilter,
                                    isLoading,
                                    pagination,
                                    showAlertBanner: isError,
                                    showProgressBars: isRefetching,
                                    sorting,
                                }}
                                positionExpandColumn={'first'}
                                positionActionsColumn={'first'}
                                positionToolbarAlertBanner="bottom"
                                localization={MRT_Localization_PT_BR}
                            />
                        </ThemeProvider>
                    </div>
                </>
            )}
        </div>
    );
};

// ESSENCIAL: Evita re-render se o pai mudar mas as props forem iguais
export default React.memo(IndustriaTabPanel);
